import Vue from 'vue';
import { ssaED, setLogger } from '@/assets/js/ssa/ssa_drushim.co.il'
import { SSALogger } from '@/assets/js/ssa/ssaLogger'
import SSAVuePlugin from './ssa.plugin'

Vue.use(SSAVuePlugin, {
  serviceUrl: process.env.ssaUrl,
  ssaED,
  SSALogger,
  setLogger
});
